<template>
  <section class="featured-hero">
    <div class="featured-hero__container">
      <article v-if="featuredArticle" class="hero-card">
        <a :href="`/${featuredArticle.category}/${featuredArticle.slug}/`" class="hero-card__link">
          <div class="hero-card__image">
            <img v-if="featuredArticle.featuredImage || featuredArticle.image" :src="featuredArticle.featuredImage || featuredArticle.image" :alt="featuredArticle.title" />
            <div class="hero-card__overlay"></div>
          </div>
          <div class="hero-card__content">
            <span class="hero-card__category">{{ categoryLabel(featuredArticle.category) }}</span>
            <h2 class="hero-card__title">{{ featuredArticle.title }}</h2>
            <p class="hero-card__excerpt">{{ featuredArticle.excerpt }}</p>
            <div class="hero-card__meta">
              <span class="hero-card__author">{{ featuredArticle.author }}</span>
              <span class="hero-card__date">{{ formatDate(featuredArticle.publishDate) }}</span>
            </div>
            <div class="hero-card__tags" v-if="featuredArticle.tags">
              <span v-for="tag in featuredArticle.tags.slice(0, 4)" :key="tag" class="hero-card__tag">
                {{ tag }}
              </span>
            </div>
          </div>
        </a>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturedHero',
  props: {
    article: {
      type: Object,
      required: false,
    },
  },
  computed: {
    featuredArticle() {
      // 如果传入了 article，使用传入的
      if (this.article) {
        return this.article
      }
      // 否则从 store 获取第一篇文章
      const articles = this.$store.state.articles.articles
      return articles && articles.length > 0 ? articles[0] : null
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    },
    categoryLabel(category) {
      const labels = {
        news: 'News',
        reviews: 'Reviews',
        guides: 'Guides',
        deals: 'Deals',
      }
      return labels[category] || category
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/css/variables.scss' as *;

.featured-hero {
  padding: $spacing-xl 0;
  background: $bg-primary;

  &__container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 $spacing-lg;
  }
}

.hero-card {
  position: relative;
  height: 500px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  }

  &__link {
    display: block;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.1) 100%);
  }

  &__content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: $spacing-xl;
    color: white;
    z-index: 1;
  }

  &__category {
    display: inline-block;
    padding: $spacing-xs $spacing-md;
    background: $primary-color;
    color: white;
    border-radius: 4px;
    font-size: $font-size-sm;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: $spacing-md;
  }

  &__title {
    font-size: $font-size-xxl;
    font-weight: 800;
    line-height: 1.2;
    margin: 0 0 $spacing-md 0;
    color: white;
  }

  &__excerpt {
    font-size: $font-size-lg;
    line-height: 1.6;
    margin: 0 0 $spacing-md 0;
    color: rgba(255, 255, 255, 0.9);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__meta {
    display: flex;
    gap: $spacing-md;
    font-size: $font-size-base;
    margin-bottom: $spacing-md;
  }

  &__author {
    font-weight: 600;
    color: white;
  }

  &__date {
    color: rgba(255, 255, 255, 0.8);

    &::before {
      content: '•';
      margin-right: $spacing-sm;
    }
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-sm;
  }

  &__tag {
    padding: $spacing-xs $spacing-sm;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 4px;
    font-size: $font-size-sm;
    color: white;
    font-weight: 500;
  }
}
</style>
